'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _facetItem = require('./facet-item');

var _facetItem2 = _interopRequireDefault(_facetItem);

var _linksoftAlbatros = require('linksoft-albatros');

var _reactCustomScrollbars = require('react-custom-scrollbars');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FacetGroup = function (_React$Component) {
    (0, _inherits3.default)(FacetGroup, _React$Component);

    function FacetGroup() {
        (0, _classCallCheck3.default)(this, FacetGroup);
        return (0, _possibleConstructorReturn3.default)(this, (FacetGroup.__proto__ || (0, _getPrototypeOf2.default)(FacetGroup)).apply(this, arguments));
    }

    (0, _createClass3.default)(FacetGroup, [{
        key: 'render',
        value: function render() {
            var self = this;

            var _ref = this.props.group || {},
                name = _ref.name,
                displayName = _ref.displayName,
                items = _ref.items;

            var headerClass = (0, _linksoftAlbatros.isMaxWidth)('lg') ? 'panel-heading collapsed' : 'panel-heading';
            var collapseContentClass = (0, _linksoftAlbatros.isMaxWidth)('lg') ? 'collapse' : 'collapse in';

            if (!items || !items.length) return null;
            return _react2.default.createElement(
                'div',
                { className: 'panel panel-default' },
                _react2.default.createElement(
                    'div',
                    { className: headerClass, 'data-toggle': 'collapse', 'data-target': '#collapseBrand-' + name },
                    _react2.default.createElement(
                        'h4',
                        { className: 'panel-title panel-opener' },
                        displayName,
                        ' ',
                        _react2.default.createElement('i', { className: 'fa fa-angle-up' })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { id: 'collapseBrand-' + name, className: collapseContentClass },
                    _react2.default.createElement(
                        _reactCustomScrollbars.Scrollbars,
                        {
                            autoHeight: true,
                            autoHeightMin: 20,
                            autoHeightMax: (0, _linksoftAlbatros.isMaxWidth)('lg') ? 9999 : 250,
                            renderView: function renderView(props) {
                                return _react2.default.createElement('div', (0, _extends3.default)({}, props, { className: 'panel-body' }));
                            }

                            // disable horizontal scroll
                            , renderTrackHorizontal: function renderTrackHorizontal(props) {
                                return _react2.default.createElement('div', (0, _extends3.default)({}, props, { className: 'track-horizontal' }));
                            },
                            renderTrackVertical: function renderTrackVertical(props) {
                                return _react2.default.createElement('div', (0, _extends3.default)({}, props, { className: 'scrollbar-track-vertical' }));
                            },
                            renderThumbVertical: function renderThumbVertical(props) {
                                return _react2.default.createElement(
                                    'div',
                                    (0, _extends3.default)({}, props, { className: 'scrollbar-thumb-vertical' }),
                                    _react2.default.createElement('div', { className: 'scrollbar-dragger' })
                                );
                            }
                        },
                        items.map(function (item) {
                            return _react2.default.createElement(_facetItem2.default, { key: name + item.value,
                                onChange: self.props.onChange,
                                item: (0, _extends3.default)({ groupName: name }, item) });
                        })
                    )
                )
            );
        }
    }]);
    return FacetGroup;
}(_react2.default.Component);

exports.default = FacetGroup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/facets/components/facet-group.js
// module id = 396
// module chunks = 0 1